import { Component, Input } from '@angular/core';
import { getDynamicRouteLink, getRouterLinkUrlById, ITableColumn } from '@lsq-frontend/common-ui';
import { LsqBaseColumnComponent } from '@lsq-frontend/common-ui';
import { atlas, CUSTOMER_OVERVIEW } from '@lsq-frontend/fasttrack-shared/routing-atlas';

@Component({
    selector: 'lsq-customer-info-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                [ngClass]="[classNames.Sortable]"
                (click)="changeSort()"
            >
                <div class="th-content">
                    {{ column.header }}
                    <div *ngIf="isSortable$ | async">
                        <lsq-icon
                            class="sort-caret"
                            [ngClass]="{ 'is-sorted': isCurrentlySorted() }"
                            [type]="getIconType()"
                            [color]="getIconColor()"
                        >
                        </lsq-icon>
                    </div>
                </div>
            </th>
            <td cdk-cell *cdkCellDef="let row; let index = index" [ngClass]="[classNames.Sortable]">
                <div class="customer-basic-info">
                    <a
                        class="customer-name preserve-case"
                        [routerLink]="[
                            getCustomerLink(customerOverviewRouterLinkUrl, row.debtorKey)
                        ]"
                    >
                        {{ row[column.key] }}
                        <lsq-ineligible-tag
                            *ngIf="row.isNoBuy"
                            [ngStyle]="{ 'padding-left': '0.3rem' }"
                        ></lsq-ineligible-tag>
                    </a>
                    <div class="customer-address">
                        <lsq-address [address]="row.address" [singleLine]="true"> </lsq-address>
                    </div>
                </div>
            </td>
        </ng-container>
    `,
    styleUrls: ['./customer-info-column.component.scss']
})
export class CustomerInfoColumnComponent extends LsqBaseColumnComponent {
    @Input() public column: ITableColumn = {
        key: 'debtorName',
        header: 'Customer',
        displayInMobileTableCardBody: false
    };
    public customerOverviewRouterLinkUrl = getRouterLinkUrlById(atlas, CUSTOMER_OVERVIEW);

    public getCustomerLink(link: string, debtorKey: string): string {
        return getDynamicRouteLink(link, { debtorKey });
    }
}
